import request from "@/utils/request";

export default function agencyOpenCloseVideoChat(id,isEnableVideoChat) {
    return request({
        url: `/news/agencyOpenCloseVideoChat/`+id+`/`+isEnableVideoChat,
        method: 'get'
    })
}